import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useActiveComponent } from '../../Components/ActiveComponentContext.js/index.jsx';
import { db } from '../../Firebase/firebase.js';
import { collection, addDoc, doc, getDoc } from 'firebase/firestore';
import { categories, countriesList } from '../../Data/pageData.jsx';
import { getStorage, ref, uploadBytes, getDownloadURL } from 'firebase/storage';
import Typography from '@mui/material/Typography';
import ClearIcon from '@mui/icons-material/Clear';
import IconButton from '@mui/material/IconButton';
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import Radio from '@mui/material/Radio';
import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Container from '@mui/material/Container';
import AddPhotoAlternateIcon from '@mui/icons-material/AddPhotoAlternate';
import FormLabel from '@mui/material/FormLabel';
import {
  Box,
  Button,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  FormGroup,
  Checkbox,
} from '@mui/material';
import { useAuth } from '../../contexts/AuthContext/index.jsx';
import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';
import PaymentForm from '../../Components/PaymentForm/index.jsx';
import imageCompression from 'browser-image-compression';
import { categoryAndTags } from '../../Data/pageData.jsx';
import SearchBar from '../../Components/SearchBar/index.jsx';

const stripePromise = loadStripe(import.meta.env.VITE_STRIPE_PUBLISHABLE_KEY);

const compressionOptions = {
  maxSizeMB: 1, // Maximum file size in MB
  maxWidthOrHeight: 1920, // Max width/height of the output image
  useWebWorker: true, // Use web workers for better performance
  initialQuality: 0.8, // Initial quality of compression (0 to 1)
};

const compressImage = async (file) => {
  try {
    const compressedFile = await imageCompression(file, compressionOptions);
    return compressedFile;
  } catch (error) {
    console.error('Error compressing image:', error);
    return file; // Return original file if compression fails
  }
};

const uploadImages = async (images) => {
  const storage = getStorage();
  return Promise.all(
    images.map(async (image) => {
      // Generate a unique filename
      const filename = `${Date.now()}_${Math.random()
        .toString(36)
        .substring(7)}.jpg`;
      const storageRef = ref(storage, `images/${filename}`);

      // Upload compressed image
      await uploadBytes(storageRef, image);
      return getDownloadURL(storageRef);
    })
  );
};

const CreatePost = () => {
  // const { t } = useTranslation(); // Multi-language support
  const navigate = useNavigate();

  const { currentUser, openLogInModal, setShowAlertDialog } = useAuth();
  const { setActivePath, backgroundColor } = useActiveComponent();
  const [title, setTitle] = useState('');
  const [description, setDescription] = useState('');
  const [category, setCategory] = useState('');
  const [phoneNumber, setPhoneNumber] = useState('');
  //const [city, setCity] = useState(''); // New state for city - reinstate when Geolocation is live
  //const [country, setCountry] = useState(''); // New state for country - reinstate when Geolocation is live
  const [city, setCity] = useState('Cuenca'); // New state for city (currently Cuenca) - reinstate to '' when Geolocation is live
  const [country, setCountry] = useState('Ecuador'); // New state for city (currently Ecuador) - reinstate to '' when Geolocation is live
  const [location, setLocation] = useState({
    city: '',
    country: '',
    coords: '',
  }); // Location object
  const [addToNewsletter, setAddToNewsletter] = useState(false);
  const [images, setImages] = useState([]);
  const [date, setDate] = useState(new Date());
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [userPhotoURL, setUserPhotoURL] = useState('');
  const [postIsPublic, setPostIsPublic] = useState(true); // default is 'public' (true)
  const [username, setUsername] = useState('');
  const [confirmation, setConfirmation] = useState('');
  const [isPosting, setIsPosting] = useState(false);
  const [featurePost, setFeaturePost] = useState(false); // Default to 'No'
  const [paymentCompleted, setPaymentCompleted] = useState(false);
  const [showPaymentForm, setShowPaymentForm] = useState(false);
  const [totalPrice, setTotalPrice] = useState(0);
  const [imageLimit, setImageLimit] = useState('6');
  const [uploadProgress, setUploadProgress] = useState(0); // Progress indicator
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState('');
  const [snackbarSeverity, setSnackbarSeverity] = useState('info'); // 'success', 'error', 'warning', 'info'
  const [clientSecret, setClientSecret] = useState(null);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [showImageRecommendationModal, setShowImageRecommendationModal] =
    useState(false);
  //const imageLimit = 3;
  //const [isExpired, setIsExpired] = useState(false);//state not really needed
  //const [frontPage, setFrontPage] = useState(false);

  // Snackbar
  const handleSnackbarClose = () => {
    setSnackbarOpen(false);
  };
  const calculateTotalPrice = () => {
    //these users can post for free
    const exemptUserIDs = [
      '4UFD7MrvMZgBTdpRUVGTporbRoD2',
      'IIPdQcAXahaJpp4JthyOJtvEXff1',
    ];
    const isExempt = currentUser && exemptUserIDs.includes(currentUser.uid);

    if (isExempt) return 0; // Exempt users always have a totalPrice of 0.

    let price = 0;
    if (imageLimit === '6') price += 0;
    if (imageLimit === '9') price += 3;
    if (imageLimit === '12') price += 5;
    if (imageLimit === '15') price += 6;
    if (featurePost) price += 5;

    return price;
  };

  const handlePaymentSuccess = () => {
    setPaymentCompleted(true);
  };

  useEffect(() => {
    const fetchClientSecret = async () => {
      try {
        const response = await fetch(
          // 'https://xploras360-server.vercel.app/api/create-payment-intent',
          `${import.meta.env.VITE_SERVER_URL}/api/create-payment-intent`,
          {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ amount: totalPrice * 100 }), // Use totalPrice instead of hardcoded value
          }
        );

        const data = await response.json();
        setClientSecret(data.clientSecret);
      } catch (error) {
        console.error('Error fetching client secret:', error);
      }
    };
    if (showPaymentForm && totalPrice > 0) fetchClientSecret();
  }, [showPaymentForm, totalPrice]);

  useEffect(() => {
    const price = calculateTotalPrice();
    setTotalPrice(price);
  }, [imageLimit, featurePost, currentUser]); // Recalculate when relevant inputs change

  useEffect(() => {
    const fetchUserDetails = async () => {
      if (currentUser) {
        // Prefill email
        setEmail(currentUser.email);
        // Fetch user data from Firestore
        const userDocRef = doc(db, 'users', currentUser.uid);
        // const maryDocsRef =  doc(db, 'users', "xP9u4NbrenWPfj5WOtGngvZQz6C2");

        const userDoc = await getDoc(userDocRef);
        // const maryDocs = await getDoc(maryDocsRef);

        // console.log("maryDocs = ",maryDocs.data().username)
        if (userDoc.exists()) {
          const userData = userDoc.data();
          //console.log("my user data is:", JSON.stringify(userData, null,2))
          // Prefill name if it exists
          setName(userData.name || '');
          setUsername(userData.username); // Ensure a default value
          setUserPhotoURL(
            userData.photo || '../images/siteImages/defaultAvatar.jpg'
          ); // Set a default avatar
          setCity(userData.location?.city || '');
          setCountry(userData.location?.country || '');
          // if (userData.name) {
          //   setName(userData.name);
          // }
          // // Set the username
          // if (userData.username) {
          //   setUsername(userData.username);
          // }
          // if (userData.photo) {
          //   setUserPhotoURL(userData.photo);
          // }
          // if (userData.location) {
          //   setCity(userData.location.city || ''); // Pre-fill city
          //   setCountry(userData.location.country || ''); // Pre-fill country
          // }
        }
      }
    };
    fetchUserDetails();
  }, []);
  const [selectedTags, setSelectedTags] = useState([]);
  const handleTagChange = (event) => {
    const { value, checked } = event.target;
    if (checked) {
      // Add the selected tag
      setSelectedTags((prevTags) => [...prevTags, value]);
    } else {
      // Remove the unselected tag
      setSelectedTags((prevTags) => prevTags.filter((tag) => tag !== value));
    }
  };

  // Add these constants at the top of your file
  const MAX_FILE_SIZE_MB = 5; // Per image limit
  const MAX_TOTAL_SIZE_MB = 50; // Total upload limit
  const RECOMMENDED_SIZE_MB = 2; // Recommended size after compression

  // Add a helper function to show users optimization tips
  const showSizeWarning = (fileSize) => {
    if (fileSize > RECOMMENDED_SIZE_MB * 1024 * 1024) {
      setSnackbarMessage(
        `Tip: Consider optimizing your image. Images around ${RECOMMENDED_SIZE_MB}MB or smaller work best.`
      );
      setSnackbarSeverity('info');
      setSnackbarOpen(true);
    }
  };

  const handleNavigation = (path) => {
    navigate(`/${path}`); // Navigate to the respective path
    setActivePath(`/${path}`);
  };

  const handleCreateMenuItemClick = (item) => {
    const path = item.toLowerCase().replace(' ', ''); // Convert item to lowercase and remove spaces
    //handleNavigation(path); // Navigate to the corresponding path
    if (currentUser) {
      const path = item.toLowerCase().replace(' ', ''); // Convert item to lowercase and remove spaces
      handleNavigation(path); // Navigate to the corresponding path
    } else {
      setShowAlertDialog(true); // Show the alert dialog to login if the user is not signed in
    }
    //handleCloseCreateMenu(); // Close the menu after clicking
  };

  // Update the handleImageChange function
  const handleImageChange = async (event) => {
    const selectedFiles = Array.from(event.target.files);
    const maxImages = parseInt(imageLimit);

    // Check individual file sizes
    const oversizedFiles = selectedFiles.filter(
      (file) => file.size > MAX_FILE_SIZE_MB * 1024 * 1024
    );
    if (oversizedFiles.length > 0) {
      setSnackbarMessage(
        `Images must be smaller than ${MAX_FILE_SIZE_MB}MB each`
      );
      setSnackbarSeverity('warning');
      setSnackbarOpen(true);
      return;
    }

    // Calculate total size including existing images
    const existingSize = images.reduce((total, file) => total + file.size, 0);
    const newTotalSize =
      selectedFiles.reduce((total, file) => total + file.size, 0) +
      existingSize;

    if (newTotalSize > MAX_TOTAL_SIZE_MB * 1024 * 1024) {
      setSnackbarMessage(
        `Total image size cannot exceed ${MAX_TOTAL_SIZE_MB}MB`
      );
      setSnackbarSeverity('warning');
      setSnackbarOpen(true);
      return;
    }
    // Check number of images
    if (images.length + selectedFiles.length <= maxImages) {
      try {
        setIsPosting(true);
        // Compress all selected images
        const compressedImages = await Promise.all(
          selectedFiles.map(async (file) => {
            const compressed = await compressImage(file);
            return compressed;
          })
        );

        setImages([...images, ...compressedImages]);
      } catch (error) {
        console.error('Error processing images:', error);
        setSnackbarMessage('Error processing images. Please try again.');
        setSnackbarSeverity('error');
        setSnackbarOpen(true);
      } finally {
        setIsPosting(false);
      }
    } else {
      setSnackbarMessage(`You can upload a maximum of ${maxImages} images.`);
      setSnackbarSeverity('warning');
      setSnackbarOpen(true);
    }
  };
  const handleRemoveImage = (index) => {
    const updatedImages = images.filter((_, i) => i !== index);
    setImages(updatedImages);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!currentUser) {
      setSnackbarMessage('You must be signed in to create a post.');
      setSnackbarSeverity('error');
      setShowAlertDialog(true); //user prompted to lognin /sign up shows up in order to create post
      setSnackbarOpen(true);
      return;
    }

    //making sure we fetch user data before submitting post -secof Mary issue of no username
    if (!username || !userPhotoURL) {
      setSnackbarMessage('Fetching user data. Please wait a moment.');
      setSnackbarSeverity('warning');
      setSnackbarOpen(true);
      return;
    }

    if (images.length === 0) {
      setShowImageRecommendationModal(true); // Show the modal to recommend adding an image
      // setSnackbarMessage('Please upload at least one image.');
      // setSnackbarSeverity('warning');
      // setSnackbarOpen(true);
      return;
    }

    if (title.trim().length === 0 || title.length > 100) {
      setSnackbarMessage('Invalid title');
      setSnackbarSeverity('error');
      setSnackbarOpen(true);
      return;
    }
    // If payment is required, show the payment form
    if (totalPrice > 0) {
      setShowPaymentForm(true);
      return;
    }
    await proceedWithSubmission();
  };

  const proceedWithSubmission = async () => {
    // Proceed with post creation directly if no payment is required
    try {
      setIsPosting(true); // Start loading
      const uploadedImageURLs =
        images.length > 0 ? await uploadImages(images) : [];

      const postDate = new Date();
      const newPost = {
        userId: currentUser.uid,
        userPhotoURL,
        username,
        title,
        description,
        category,
        name,
        email,
        location: { city, country }, // Include city and country in the post data
        featurePost,
        timestamp: postDate.toISOString(),
        images: uploadedImageURLs,
        readableDate: postDate.toLocaleDateString(),
        readableTime: postDate.toLocaleTimeString(),
        isPublic: postIsPublic,
        isExpired: false,
        bookmarkCount: 0,
        tags: selectedTags || null,
      };
      console.log('Post data being sent:', newPost); // Log the post object
      // Set the featuredUntil date if featurePost is true
      if (featurePost) {
        const expirationDate = new Date();
        expirationDate.setDate(expirationDate.getDate() + 14); // Add 14 days
        newPost.featuredUntil = expirationDate.toISOString(); // Store the expiration date
      }
      const docRef = await addDoc(collection(db, 'posts'), newPost);

      setTitle('');
      setDescription('');
      setCategory('');
      setName(name);
      setEmail(email);
      setCity(city);
      setCountry(country);
      setFeaturePost(false);
      setImages([]);
      setSelectedTags([]);
      setDate(new Date());
      setSnackbarMessage('Post created successfully!');
      setSnackbarSeverity('success');
      setSnackbarOpen(true);
    } catch (e) {
      console.error('Error adding document: ', e);
      setSnackbarMessage('Failed to create post. Please try again.');
      setSnackbarSeverity('error');
      setSnackbarOpen(true);
    } finally {
      setIsPosting(false);
    }
  };

  const fontColor = backgroundColor === '#ffffff' ? 'black' : 'lightgrey';
  const isDEV = process.env.NODE_ENV === 'development';

  return (
    <>
      <Box
        sx={{
          display: { xs: 'flex', sm: 'flex', lg: 'none', xl: 'none' },
          alignItems: 'center',
          justifyContent: 'center',
          backgroundColor: 'white',
          pb: 0.5,
          height: 45,
          ml: { xs: 1, sm: 1, md: 1, lg: 1, xl: 1 },
          position: 'sticky',
          top: 0,
          zIndex: 1000, // Ensure it's above other content while scrolling
          mb: 0,
        }}
      >
        <SearchBar width={300} />
      </Box>
      <Box
        sx={{
          height: '100vh',
          overflowY: showPaymentForm ? 'hidden' : 'auto',
          display: 'flex',
        }}
      >
        {showPaymentForm ? (
          clientSecret ? (
            <Elements stripe={stripePromise} options={{ clientSecret }}>
              <Container maxWidth='xl' sx={{ pb: 0 }}>
                <PaymentForm
                  onPaymentSuccess={async () => {
                    try {
                      // Ensure the payment form closes
                      setShowPaymentForm(false);
                      // Proceed with form submission after payment is completed
                      setIsPosting(true); // Start posting process
                      const uploadedImageURLs = await uploadImages(images);
                      const postDate = new Date();
                      const newPost = {
                        userId: currentUser.uid,
                        userPhotoURL,
                        username,
                        title,
                        description,
                        category,
                        name,
                        email,
                        location: { city, country }, // Include city and country in the post data
                        featurePost,
                        timestamp: postDate.toISOString(),
                        images: uploadedImageURLs,
                        readableDate: postDate.toLocaleDateString(),
                        readableTime: postDate.toLocaleTimeString(),
                        isPublic: postIsPublic,
                        isExpired: false,
                        bookmarkCount: 0,
                        tags: selectedTags || null,
                      };

                      // Save post to Firestore
                      const docRef = await addDoc(
                        collection(db, 'posts'),
                        newPost
                      );

                      // Reset form fields
                      setTitle('');
                      setDescription('');
                      setCategory('');
                      setName(name);
                      setEmail(email);
                      setCity(city);
                      setCountry(country);
                      setFeaturePost(false);
                      setImages([]);
                      setSelectedTags([]);
                      setDate(new Date());
                      setSnackbarMessage('Post created successfully!');
                      setSnackbarSeverity('success');
                      setSnackbarOpen(true);
                    } catch (error) {
                      console.error('Error adding document: ', error);
                      setSnackbarMessage(
                        'Failed to create post. Please try again.'
                      );
                      setSnackbarSeverity('error');
                      setSnackbarOpen(true);
                    } finally {
                      setIsPosting(false);
                    }
                  }}
                  onCancel={() => {
                    setShowPaymentForm(false);
                    setClientSecret(null); // Clear the client secret when canceling
                  }}
                  totalPrice={totalPrice}
                />
              </Container>
            </Elements>
          ) : (
            <Box sx={{ display: 'flex', justifyContent: 'center', mt: 4 }}>
              <CircularProgress />
            </Box>
          )
        ) : (
          <Container maxWidth='xl' sx={{ pb: 0 }}>
            <Box
              sx={{
                height: '100vh',
                mt: 0,
                boxSizing: 'border-box',
                display: 'flex',
                justifyContent: 'center',
              }}
            >
              <Box
                component='form'
                onSubmit={handleSubmit}
                sx={{
                  mt: 2,
                  mb: 0,
                  ml: {
                    xs: 'auto',
                    sm: 'auto',
                    md: 'auto',
                    lg: 'auto',
                    xl: 'auto',
                  },
                  mr: {
                    xs: 'auto',
                    sm: 'auto',
                    md: 'auto',
                    lg: 'auto',
                    xl: 'auto',
                  },
                  p: 1,
                  width: {
                    xs: '100%',
                    sm: '100%',
                    md: '100%',
                    lg: '90%',
                    xl: '80%',
                  },
                  boxSizing: 'border-box',
                }}
              >
                <Grid container spacing={3}>
                  {/* Title */}
                  <Grid
                    item
                    xs={12}
                    md={6}
                    lg={6}
                    xl={8}
                    sx={{
                      display: 'flex',
                      flexDirection: 'column',
                      gap: 4,
                    }}
                  >
                    <TextField
                      fullWidth
                      placeholder='Enter post title (Max.100 Characters)'
                      variant='standard'
                      value={title}
                      onChange={(e) => setTitle(e.target.value)}
                      inputProps={{ maxLength: 100 }}
                      required
                      sx={{
                        mb: 0,
                        border: 'none',
                        '& .MuiInputBase-input': {
                          fontFamily: 'Montserrat, sans-serif',
                          fontWeight: 'bold',
                          fontSize: {
                            xs: '1rem',
                            sm: '1rem',
                            md: '1.3rem',
                            lg: '1.42rem',
                            xl: '1.42rem',
                          },
                        },
                      }}
                    />
                    {/* Description */}
                    <TextField
                      fullWidth
                      label='Description'
                      variant='outlined'
                      multiline
                      rows={4}
                      value={description}
                      onChange={(e) => setDescription(e.target.value)}
                      required
                    />

                    {/* Parent Grid Container */}
                    {/* Remove for now and implement later  when Geolocation is live */}
                    <Grid
                      container
                      spacing={2} // Adds spacing between items
                      sx={{
                        alignItems: 'center', // Vertically center items
                      }}
                    >
                      {/* City */}
                      {/* Remove for now and implement later  when Geolocation is live */}
                      <Grid
                        item
                        xs={12}
                        md={6}
                        lg={6}
                        xl={6}
                        sx={{
                          display: 'flex',
                          flexDirection: 'column',
                          gap: 5,
                        }}
                      >
                        <TextField
                          fullWidth
                          //placeholder='Enter the title of your post (Max.100 Characters)'
                          //variant='standard'
                          //inputProps={{ maxLength: 100 }}
                          value={city}
                          onChange={(e) => setCity(e.target.value)}
                          label='City'
                          //required
                        />
                      </Grid>

                      {/* Country */}
                      {/* Remove for now and implement later  when Geolocation is live */}
                      <Grid
                        item
                        xs={12}
                        sm={6}
                        sx={{
                          pb: 0,
                          maxHeight: country ? '160px' : '50px',
                        }}
                      >
                        <FormControl fullWidth>
                          <InputLabel>Country</InputLabel>
                          {/* This method allows me to display country flags */}
                          <Select
                            value={country}
                            onChange={(e) => setCountry(e.target.value)}
                            required
                            label='Country'
                            renderValue={(selected) => (
                              <Box
                                sx={{
                                  display: 'flex',
                                  alignItems: 'center',
                                  gap: 1,
                                }}
                              >
                                {countriesList.find(
                                  (item) => item.label === selected
                                )?.code && (
                                  <img
                                    src={`https://flagcdn.com/w40/${countriesList
                                      .find((item) => item.label === selected)
                                      .code.toLowerCase()}.png`}
                                    alt=''
                                    width='20'
                                    style={{ borderRadius: '3px' }}
                                  />
                                )}
                                {selected}
                              </Box>
                            )}
                          >
                            {countriesList.map((cat) => (
                              <MenuItem key={cat.code} value={cat.label}>
                                <Box
                                  sx={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: 1,
                                  }}
                                >
                                  {cat.code && (
                                    <img
                                      src={`https://flagcdn.com/w40/${cat.code.toLowerCase()}.png`}
                                      alt=''
                                      width='20'
                                      style={{ borderRadius: '3px' }}
                                    />
                                  )}
                                  {cat.label}
                                </Box>
                              </MenuItem>
                            ))}
                          </Select>
                        </FormControl>
                      </Grid>
                    </Grid>

                    {/* Categories */}
                    <Grid
                      item
                      xs={12}
                      sm={12}
                      sx={{
                        pb: 0,
                        maxHeight: category ? '50px' : '50px', //size changes based on if category is picked
                      }}
                    >
                      <FormControl fullWidth>
                        <InputLabel>Categories</InputLabel>
                        <Select
                          value={category}
                          onChange={(e) => setCategory(e.target.value)}
                          required
                          label='Category'
                        >
                          {categories.map((cat) => (
                            <MenuItem key={cat} value={cat}>
                              {cat}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                      {/* Add tags code here, when we are able to search with tags */}
                    </Grid>

                    {/* Feature post here */}
                    {isDEV && (
                      <FormControl component='fieldset' sx={{ mt: 0 }}>
                        <FormLabel component='legend'>Feature Post ?</FormLabel>
                        <Box
                          sx={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: 1.5,
                          }}
                        >
                          <Typography
                            variant='body1'
                            sx={{
                              color: 'grey',
                              fontSize: 14,
                              fontStyle: 'italic',
                            }}
                          >
                            Select 'Yes' to feature your post at the top of the
                            homepage for 2 weeks.
                          </Typography>
                          <Typography
                            variant='h5'
                            sx={{
                              color: 'black',
                            }}
                          >
                            $5
                          </Typography>
                        </Box>
                        <RadioGroup
                          row
                          aria-label='featurePost'
                          name='featurePost'
                          value={featurePost}
                          onChange={(e) =>
                            setFeaturePost(e.target.value === 'true')
                          }
                        >
                          <FormControlLabel
                            value={false}
                            control={<Radio />}
                            label='No'
                          />
                          <FormControlLabel
                            value={true}
                            control={<Radio />}
                            label='Yes ($5)'
                          />
                        </RadioGroup>
                      </FormControl>
                    )}
                  </Grid>

                  {/* IMAGES */}
                  <Grid item xs={12} sm={6}>
                    <Grid
                      item
                      xs={12}
                      sm={4}
                      md={4}
                      lg={8}
                      sx={{
                        ml: { xs: 'auto' },
                        mr: 'auto',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                      }}
                    >
                      {images.length === 0 ? (
                        <Button
                          variant='outlined'
                          component='label'
                          fullWidth
                          disabled={isPosting}
                          sx={{
                            border: '1px dashed lightgrey',
                            pl: 0,
                            pr: 0,
                            pt: 5,
                            pb: 5,
                            //mt: category && 15, // Conditional margin-top
                            display: 'flex',
                            flexDirection: 'column',
                            justifyContent: 'center',
                            alignItems: 'center',
                            height: {
                              xs: 'auto',
                              sm: 'auto',
                              md: 'auto',
                              lg: 260,
                              xl: 260,
                            },
                          }}
                        >
                          <AddPhotoAlternateIcon
                            sx={{
                              fontSize: {
                                xs: 50,
                                sm: 50,
                                md: 70,
                                lg: 80,
                                xl: 80,
                              },
                              color: 'rgb(200,200,200, 0.4)',
                              mb: 2,
                            }}
                          />
                          Add Feature Image
                          <input
                            type='file'
                            hidden
                            multiple
                            accept='image/*'
                            onChange={handleImageChange}
                            disabled={images.length >= parseInt(imageLimit)}
                          />
                        </Button>
                      ) : (
                        <Box
                          sx={{
                            position: 'relative',
                            width: '100%',
                            height: '100%',
                          }}
                        >
                          <img
                            src={URL.createObjectURL(images[0])}
                            alt='feature-upload'
                            style={{
                              width: '100%',
                              height: '100%',
                              objectFit: 'cover',
                              borderRadius: 'inherit',
                            }}
                          />
                          <IconButton
                            component='label'
                            sx={{
                              position: 'absolute',
                              bottom: -10,
                              right: -10,
                              backgroundColor: 'white',
                              border: '2px solid lightgrey',
                              zIndex: 10,
                              '&:hover': {
                                backgroundColor: 'lightgrey',
                              },
                            }}
                          >
                            <AddPhotoAlternateIcon />
                            <input
                              type='file'
                              hidden
                              multiple
                              accept='image/*'
                              onChange={handleImageChange}
                              disabled={images.length >= parseInt(imageLimit)}
                            />
                          </IconButton>
                          <IconButton
                            sx={{
                              position: 'absolute',
                              top: -6,
                              right: -6,
                              backgroundColor: 'white',
                              zIndex: 10,
                            }}
                            onClick={() => handleRemoveImage(0)}
                          >
                            <ClearIcon fontSize='small' color='error' />
                          </IconButton>
                        </Box>
                      )}
                    </Grid>

                    <FormControl component='fieldset'>
                      <RadioGroup
                        row
                        aria-label='imageLimit'
                        name='imageLimit'
                        value={imageLimit}
                        onChange={(e) => setImageLimit(e.target.value)}
                        sx={{
                          mt: 2,
                          ml: { xs: 0, sm: 0, md: 0, lg: 11.5, xl: 0 },
                        }}
                      >
                        <Box
                          sx={{
                            border: '1px dashed navy',
                            mb: 2,
                            ml: { xs: 0, sm: 0, md: 0, lg: 3, xl: 3 },
                            borderRadius: 2,
                            p: 1,
                          }}
                        >
                          <FormControlLabel
                            value='6'
                            control={<Radio />}
                            label={
                              <Box
                                sx={{
                                  backgroundColor: 'white',
                                  display: 'flex',
                                  justifyContent: 'space-between',
                                  alignItems: 'center',
                                  p: 0.5,
                                  borderRadius: 1,
                                  color: 'navy',
                                  width: {
                                    xs: '245px',
                                    sm: '300px',
                                    md: '300px',
                                    lg: '300px',
                                    xl: '300px',
                                  },
                                }}
                              >
                                <Box
                                  sx={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                  }}
                                >
                                  <Typography variant='body1'>
                                    6 Images
                                  </Typography>
                                  <Typography
                                    variant='body2'
                                    sx={{
                                      fontSize: 13,
                                      fontStyle: 'italic',
                                    }}
                                  >
                                    You can add a maximum of 6 images
                                  </Typography>
                                </Box>
                                <Typography variant='body1'>Free</Typography>
                              </Box>
                            }
                          />
                        </Box>
                        {/* Change this to isDEV so it doesn't show in production mode */}
                        {isDEV && (
                          <FormControl component='fieldset'>
                            <RadioGroup
                              row
                              aria-label='imageLimit'
                              name='imageLimit'
                              value={imageLimit}
                              onChange={(e) => setImageLimit(e.target.value)}
                              sx={{
                                mt: 2,
                                ml: { xs: 0, sm: 0, md: 0, lg: 0, xl: 0 },
                              }}
                            >
                              <Box
                                sx={{
                                  border: '1px dashed navy',
                                  mb: 2,
                                  ml: { xs: 0, sm: 0, md: 0, lg: 3, xl: 3 },
                                  borderRadius: 2,
                                  p: 1,
                                }}
                              >
                                <FormControlLabel
                                  value='3'
                                  control={<Radio />}
                                  label={
                                    <Box
                                      sx={{
                                        backgroundColor: 'white',
                                        display: 'flex',
                                        justifyContent: 'space-between',
                                        alignItems: 'center',
                                        p: 0.5,
                                        borderRadius: 1,
                                        color: 'navy',
                                        width: {
                                          xs: '245px',
                                          sm: '300px',
                                          md: '300px',
                                          lg: '300px',
                                          xl: '300px',
                                        },
                                      }}
                                    >
                                      <Box
                                        sx={{
                                          display: 'flex',
                                          flexDirection: 'column',
                                        }}
                                      >
                                        <Typography variant='body1'>
                                          3 Images
                                        </Typography>
                                        <Typography
                                          variant='body2'
                                          sx={{
                                            fontSize: 13,
                                            fontStyle: 'italic',
                                          }}
                                        >
                                          You can add 3 images for free
                                        </Typography>
                                      </Box>
                                      <Typography variant='body1'>
                                        Free
                                      </Typography>
                                    </Box>
                                  }
                                />
                              </Box>
                              {/* +6 more images, 9 total */}
                              <Box
                                sx={{
                                  border: '1px dashed navy',
                                  mb: 2,
                                  borderRadius: 2,
                                  p: 1,
                                  ml: { xs: 0, sm: 0, md: 0, lg: 3, xl: 3 },
                                }}
                              >
                                <FormControlLabel
                                  value='9'
                                  control={<Radio />}
                                  label={
                                    <Box
                                      sx={{
                                        backgroundColor: 'white',
                                        display: 'flex',
                                        justifyContent: 'space-between',
                                        alignItems: 'center',
                                        p: 0.5,
                                        borderRadius: 1,
                                        color: 'navy',
                                        width: {
                                          xs: '245px',
                                          sm: '300px',
                                          md: '300px',
                                          lg: '300px',
                                          xl: '300px',
                                        },
                                      }}
                                    >
                                      <Box
                                        sx={{
                                          display: 'flex',
                                          flexDirection: 'column',
                                        }}
                                      >
                                        <Typography variant='body1'>
                                          +6 more
                                        </Typography>
                                        <Typography
                                          variant='body2'
                                          sx={{
                                            fontSize: 13,
                                            fontStyle: 'italic',
                                          }}
                                        >
                                          Add six more images (9 total)
                                        </Typography>
                                      </Box>
                                      <Typography variant='body1'>
                                        $3
                                      </Typography>
                                    </Box>
                                  }
                                />
                              </Box>
                              {/* + 9 more images- 12 total */}
                              <Box
                                sx={{
                                  border: '1px dashed navy',
                                  mb: 2,
                                  borderRadius: 2,
                                  p: 1,
                                  ml: { xs: 0, sm: 0, md: 0, lg: 3, xl: 3 },
                                }}
                              >
                                <FormControlLabel
                                  value='12'
                                  control={<Radio />}
                                  label={
                                    <Box
                                      sx={{
                                        backgroundColor: 'white',
                                        display: 'flex',
                                        justifyContent: 'space-between',
                                        alignItems: 'center',
                                        p: 0.5,
                                        borderRadius: 1,
                                        color: 'navy',
                                        width: {
                                          xs: '245px',
                                          sm: '300px',
                                          md: '300px',
                                          lg: '300px',
                                          xl: '300px',
                                        },
                                      }}
                                    >
                                      <Box>
                                        <Typography variant='body1'>
                                          +9 more
                                        </Typography>
                                        <Typography
                                          variant='body2'
                                          sx={{
                                            fontSize: 13,
                                            fontStyle: 'italic',
                                          }}
                                        >
                                          Add 9 more images (12 total)
                                        </Typography>
                                      </Box>
                                      <Typography variant='body1'>
                                        $5
                                      </Typography>
                                    </Box>
                                  }
                                />
                              </Box>
                              {/* +12 more images - 15 images */}
                              <Box
                                sx={{
                                  border: '1px dashed navy',
                                  mb: 2,
                                  borderRadius: 2,
                                  p: 1,
                                  ml: { xs: 0, sm: 0, md: 0, lg: 3, xl: 3 },
                                }}
                              >
                                <FormControlLabel
                                  value='15'
                                  control={<Radio />}
                                  label={
                                    <Box
                                      sx={{
                                        backgroundColor: 'white',
                                        display: 'flex',
                                        justifyContent: 'space-between',
                                        alignItems: 'center',
                                        p: 0.5,
                                        borderRadius: 1,
                                        color: 'navy',
                                        width: {
                                          xs: '245px',
                                          sm: '300px',
                                          md: '300px',
                                          lg: '300px',
                                          xl: '300px',
                                        },
                                      }}
                                    >
                                      <Box>
                                        <Typography variant='body1'>
                                          +12 more
                                        </Typography>
                                        <Typography
                                          variant='body2'
                                          sx={{
                                            fontSize: 13,
                                            fontStyle: 'italic',
                                          }}
                                        >
                                          Add 12 more images (15 total)
                                        </Typography>
                                      </Box>
                                      <Typography variant='body1'>
                                        $6
                                      </Typography>
                                    </Box>
                                  }
                                />
                              </Box>
                            </RadioGroup>
                          </FormControl>
                        )}
                      </RadioGroup>
                    </FormControl>
                  </Grid>

                  <Grid item xs={12}>
                    <Box
                      sx={{
                        display: 'flex',
                        flexWrap: 'wrap',
                        gap: 2,
                        mt: 2,
                        mb: 2,
                        justifyContent: 'center',
                      }}
                    >
                      {images.map((image, index) => (
                        <Box
                          key={index}
                          sx={{
                            position: 'relative',
                            width: 100,
                            height: 100,
                            border: '1px solid lightgrey',
                            borderRadius: 2,
                          }}
                        >
                          <img
                            src={URL.createObjectURL(image)}
                            alt={`upload-${index}`}
                            style={{
                              width: '100%',
                              height: '100%',
                              objectFit: 'cover',
                              borderRadius: 'inherit',
                            }}
                          />
                          <IconButton
                            sx={{
                              position: 'absolute',
                              top: -6,
                              right: -9,
                              backgroundColor: 'black',
                              p: 0,
                            }}
                            onClick={() => handleRemoveImage(index)}
                          >
                            <ClearIcon fontSize='small' color='error' />
                          </IconButton>
                        </Box>
                      ))}
                    </Box>
                  </Grid>
                </Grid>
                <Box
                  sx={{
                    display: 'flex',
                    justifyContent: 'center',
                    ml: 'auto',
                    mr: 'auto',
                    width: { lg: '30%', xl: '30%' },
                  }}
                >
                  {/* switch these around so that this one appears in production instead */}
                  {!isDEV && (
                    <Button
                      variant='contained'
                      color='primary'
                      type='submit'
                      disabled={isPosting}
                      sx={{ borderRadius: 8, backgroundColor: 'darkblue' }}
                    >
                      {isPosting ? 'Creating Post...' : `Create Post`}
                    </Button>
                  )}
                  {isDEV && (
                    <Button
                      variant='contained'
                      color='primary'
                      type='submit'
                      disabled={isPosting}
                      sx={{ borderRadius: 8, backgroundColor: 'darkblue' }}
                    >
                      {isPosting
                        ? 'Creating Post...'
                        : `Create Post $${totalPrice}.00`}
                    </Button>
                  )}
                </Box>
                <Box sx={{ display: 'flex', justifyContent: 'center' }}>
                  <Typography
                    variant='body1'
                    color='secondary'
                    sx={{ mt: 2, textAlign: 'center' }}
                  >
                    {confirmation}
                  </Typography>
                </Box>
              </Box>
              {/* Modal for image recommendation */}
              <Dialog
                open={showImageRecommendationModal}
                onClose={() => setShowImageRecommendationModal(false)}
              >
                <DialogTitle>Add an Image?</DialogTitle>
                <DialogContent>
                  <DialogContentText>
                    Adding an image can make your post more visually appealing
                    to other users. Would you like to add an image or continue
                    without one?
                  </DialogContentText>
                </DialogContent>
                <DialogActions>
                  <Button
                    onClick={() => setShowImageRecommendationModal(false)}
                    color='primary'
                  >
                    Cancel
                  </Button>
                  <Button
                    onClick={() => {
                      proceedWithSubmission(); // Call the function
                      setShowImageRecommendationModal(false); // Close the modal
                    }}
                    color='primary'
                    autoFocus
                  >
                    Continue Without Image
                  </Button>
                </DialogActions>
              </Dialog>
              <Backdrop
                sx={{
                  color: '#fff',
                  zIndex: (theme) => theme.zIndex.drawer + 1,
                }}
                open={isPosting}
              >
                <CircularProgress color='inherit' />
              </Backdrop>
            </Box>
          </Container>
        )}
      </Box>
      <Snackbar
        open={snackbarOpen}
        autoHideDuration={snackbarSeverity === 'success' ? 5000 : null}
        onClose={handleSnackbarClose}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
      >
        <MuiAlert
          elevation={6}
          variant='filled'
          onClose={snackbarSeverity !== 'success' ? handleSnackbarClose : null}
          severity={snackbarSeverity}
        >
          {snackbarMessage}
        </MuiAlert>
      </Snackbar>
    </>
  );
};

export default CreatePost;

//Tags, right below the categories
{
  /* {category && (
                          <FormControl fullWidth>
                            <Typography
                              variant='body'
                              gutterBottom
                              sx={{ mt: 2, }}
                            >
                              Add Tags (Optional)
                            </Typography>
                            <FormGroup row>
                              {categoryAndTags
                                .find((cat) => cat.name === category)
                                ?.tags.map((tag) => (
                                  <FormControlLabel
                                  
                                    key={tag}
                                    control={
                                      <Checkbox
                                        value={tag}
                                        checked={selectedTags.includes(tag)}
                                        onChange={handleTagChange}
                                      />
                                    }
                                    label={tag}
                                  />
                                ))}
                            </FormGroup>
                          </FormControl>
                        )} */
}

//PREVIOUS COUNTRY SELECT FIELD:
{
  /* <Select
                          value={country}
                          onChange={(e) => setCountry(e.target.value)}
                          // required
                          label='Country'
                        >
                          {countriesList.map((cat) => (
                            <MenuItem key={cat} value={cat.label}>
                              {cat.label}
                            </MenuItem>
                          ))}
                        </Select> */
}

//underneath setisPosting(true)
// const storage = getStorage();
// const uploadedImageURLs = await Promise.all(
//   images.map(async (image) => {
//     const storageRef = ref(storage, `images/${image.name}`);
//     await uploadBytes(storageRef, image);
//     const downloadURL = await getDownloadURL(storageRef);
//     return downloadURL;
//   })
// );

// const uploadedImageURLs = await uploadImages(images);//before
// Only upload images if they are provided. Make it possible for users to submit posts without images
